import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class AccountCancellation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // document.title = '服务协议';
    return (
      <div className="page_type_h5">
        <article id="AccountCancellation">
          <h2>慧管车账号注销须知</h2>
          <section>亲爱的慧管车用户：</section>
          <section>
            您在申请注销流程中点击同意前，应当认真阅读《慧管车账号注销须知》（以下称“《注销须知》”）。
          </section>
          <section>
            请您务必审慎阅读、充分理解《注销须知》中相关条款内容，其中包括：
            <br />
            1、与您约定免除或限制责任的条款；
            <br />
            2、其他以粗体标识的重要条款。
          </section>
          <section>
            如您对本《注销须知》有任何疑问，可拨打我们的客服电话400-826-2266联系客服。
          </section>
          <p>
            【特别提示】当您按照注销页面提示填写信息、阅读并同意本《注销须知》及相关条款与条件且完成全部注销程序后，即表示您已充分阅读、理解并接受本《注销须知》的全部内容。阅读本《注销须知》的过程中，如果您不同意相关任何条款和条件约定，请您立即停止账户注销程序。
          </p>
          <p>
            我们在此善意地提醒您，
            您注销账户的行为会给您带来诸多不便，且注销慧管车账户后，您的个人信息我们会在慧联智控系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。
          </p>
          <section>
            <h3>1、如果您仍执意注销账户，您的账户需同时满足以下条件：</h3>
            <p>(1)您的账户非您所归属的慧管车系统初始开通账户</p>
          </section>
          <section>
            <p>
              2、慧管车账户一旦被注销将不可恢复，请您在操作之前自行备份账户相关的所有信息和数据，请您保存好订单和服务的交易凭证、票据等资料。
            </p>
            <br />
            <p>
              3、在慧管车账户注销期间，如果您的账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，慧管车有权自行终止本账户的注销而无需另行得到您的同意。
            </p>
          </section>
          <section>
            <p>
              <b>
                4、注销慧管车账户，您将无法再使用本账户，也将无法找回您慧管车账户中及与账户相关的任何内容或信息，
                包括但不限于：
              </b>
            </p>
            <p>(1)您将无法登录、使用本慧管车账户；</p>
            <p>
              (2)本慧管车账户的个人资料和历史信息（包括但不限于用户名、头像、订单记录等）都将无法找回。
            </p>
          </section>
          <section>
            <p>
              <b>
                5、注销本慧管车账户并不代表本慧管车账户注销前的账户行为和相关责任得到豁免或减轻。
              </b>
            </p>
          </section>
        </article>
      </div>
    );
  }
}

export default AccountCancellation;



// WEBPACK FOOTER //
// ./src/staticPage/accountCancellation2/index.js